import {
  Sparkles, Search, HeartPulse, Activity, Eye, Wrench, Heart, Star,
  Music, Compass, Coffee, Package, Zap, Smile, Camera, Bell, Shield,
  Award, Map, Sun, Moon, Cloud, Anchor, Flame, Leaf, Rocket, Trophy,
  ChefHat, ShoppingBag, Layers, Smartphone, Lock, Feather, Share2,
  CheckCircle2, MessageCircle, Image, Tag, Calendar, Globe, Headphones,
} from "lucide-react";

export const ICON_MAP = {
  Sparkles, Search, HeartPulse, Activity, Eye, Wrench, Heart, Star,
  Music, Compass, Coffee, Package, Zap, Smile, Camera, Bell, Shield,
  Award, Map, Sun, Moon, Cloud, Anchor, Flame, Leaf, Rocket, Trophy,
  ChefHat, ShoppingBag, Layers, Smartphone, Lock, Feather, Share2,
  CheckCircle2, MessageCircle, Image, Tag, Calendar, Globe, Headphones,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export const getIcon = (name) => ICON_MAP[name] || Sparkles;
